<template>
  <div id="pay-container">
    <button
      class="back-btn flex-center j-change-product"
      id="backBtn"
      @click="handleReSelectProduct"
    >
      <Icon class="back-ico" name="right"></Icon>
      {{ letter.productSwitch }}
    </button>
    <div class="pay-container">
      <div class="left">
        <login-info
          class="login-info"
          :showSwicthBtn="false"
          :showIcon="true"
        ></login-info>

        <!-- 银行汇款&点卡自定义支付 -->
        <div v-if="(canSelectMoney && !isCoins) || isBank" class="custom-pay">
          <p class="pay-title">{{ letter.selectPayment }}</p>
          <Payment
            v-if="canSelectMoney && !isCoins"
            :languages="letter"
            :curPayType="curPayType"
            :curProduct="curProduct"
            :curPrice="curPrice"
            :pricesList="pricesList"
            @showError="showCreateFaileTips"
            @selectPayMent="selectPayMent"
          ></Payment>
          <BankPay
            v-if="isBank"
            :isCoins="isCoins"
            :game-id="gameId"
            :role-id="roleId"
            :role-name="roleName"
            :languages="letter"
            :server-id="ourServerId"
            :cur-pay-type="curPayType"
            @showError="showCreateFaileTips"
            @selectPrice="selectPrice"
          ></BankPay>
        </div>
        <!-- 正常支付的商品 -->
        <order-product
          v-else
          class="order-product"
          :curProduct="curProduct"
          :curPriceSubCoin="curPriceSubCoin"
          :curPriceExtraCoin="curPriceExtraCoin"
        ></order-product>
        <order-info
          v-if="!isBank"
          class="order-info"
          :curProduct="curProduct"
          :curPayType="curPayType"
          :realTotalPrice="realTotalPrice"
          :realCartTotalPrice="realCartTotalPrice"
          :transMount="transMount"
          :discountTransMount="discountTransMount"
        ></order-info>
      </div>
      <div class="right">
        <div class="pay-info">
          <span class="pay-title" id="selectPayTypeTitle">
            {{ letter.choosePayWay }}
          </span>
          <div
            v-if="hideJpAreaSelector"
            class="area-selector j-area-dcount"
            @click="handleAreaConfirmPopup"
          >
            {{ curLocation || letter.areaLimitSwitchRegion }}
            <Icon class="area-icon" name="down" />
          </div>
        </div>
        <div class="select-paytype-info">
          <div class="paytype-info-container" v-if="undefined != curProduct">
            <select-pay-way
              :isFuntapGame="isFuntapGame"
              :curPayType="curPayType"
              :lastPayType="lastPayType"
              :allPayTypes="allPayTypes"
              :showPayWaySelecter="showPayWaySelecter"
              :gameId="gameId"
              :roleId="roleId"
              :roleName="roleName"
              :ourServerId="ourServerId"
              :curCard="curCard"
              :isReload="isReload"
              :curProduct="curProduct"
              :curPrice="curPrice"
              :pricesList="pricesList"
              :curLocationVal="curLocationVal"
              :curCoins="curCoins"
              :isCoins="isCoins"
              :discountTransMount="discountTransMount"
              @selectPayWay="selectPayType"
              @showError="showCreateFaileTips"
              @selectCard="selectCard"
              @deleteCurPayTypeCard="deleteCurPayTypeCard"
              @resetReload="isReload = false"
              @selectPayMent="selectPayMent"
            ></select-pay-way>
          </div>
        </div>
        <form v-bind:action="postAction" method="post">
          <input
            v-for="(value, key) in post_fields"
            :key="key"
            type="hidden"
            :name="key"
            :value="value"
          />
          <button type="submit" id="postOrderToBank" class="hide"></button>
        </form>
        <ProductSelecter
          v-if="showProductSelecter"
          @select-product="handleSelectProduct"
          v-on:closeSelecter="showProductSelecter = false"
          v-bind:showChildSelector="showProductSelecter"
          :curProduct="curProduct"
        ></ProductSelecter>
        <PaymentSelecter
          v-if="showPaymentSelecter"
          @closeSelecter="showPaymentSelecter = false"
          :curPayType="curPayType"
          :curProduct="curProduct"
          :curPrice="curPrice"
          :pricesList="pricesList"
          v-bind:showChildSelector="showPaymentSelecter"
          @selectPayMent="selectPayMent"
          style="z-index: 1002"
        ></PaymentSelecter>
        <!-- 
        给order-sum加key促使vue重新渲染不要复用这个DOM的原因：
          可能是 Safari 的渲染/重绘问题：你的模板里合计展示在 .submit-wrap，该块使用了 position: sticky，
          而项目全局样式有 -webkit-overflow-scrolling: touch（在 src/resource/assets/scss/officialTopup/base.scss 等基类里）。
          Safari 在 sticky + 滚动容器（有 overflow）+ 触控惯性滚动 组合下存在已知的重绘 bug：虚拟 DOM 已更新
         （你在 DOM 面板能看到 realCartTotalPrice/realTotalPrice 新值），但合成层不触发重绘，屏幕仍显示旧文本，直到发生滚动或某个样式变化才会刷新。
        -->
        <div class="submit-wrap">
          <div
            class="order-sum flex-center"
            :key="`${realCartTotalPrice}-${realTotalPrice}`"
          >
            <span>{{ letter.storeTotal }}</span>
            <span class="total" v-if="openShoppingCart && isCart"
              >{{ realCartTotalPrice }} {{ curPayType.currency || '' }}
            </span>
            <span v-else class="total"
              >{{ realTotalPrice }} {{ curPayType.currency || '' }}
            </span>
          </div>
          <Button
            class="submit-btn normal-btn j-submit-nbtn"
            @click="postOrder"
            pointClass="j-submit-dcount j-submit-nbtn"
            :loading="submitLoading"
          >
            {{ submitOrderBtnText }}
          </Button>
        </div>
      </div>
      <transition name="fade">
        <PointCard
          @closePointCardEditor="closePointCardEditor"
          @payWidthPointCard="payWidthPointCard"
          v-if="showPointCardEditor && curPrice != undefined"
          v-bind:type="curPayType.type"
          :curPayType="curPayType"
          :curPrice="curPrice"
          v-model="showPaymentSelecter"
          v-bind:amount="curPrice.TRANS_AMOUNT + ' ' + curPrice.CURRENCY"
          :currLocation="curLocationVal"
        ></PointCard>
      </transition>
      <transition name="fade">
        <div class="diaglog-wrapper" v-if="showErrorPayType">
          <article class="dialog-container">
            <div class="tips-dialog-wrapper">
              <h1 class="dialog-title account">{{ passportLanguages.tips }}</h1>
              <div class="tips-content" style="display: block">
                <p class="left-text">
                  {{ letter.store_product_paytype_error }}
                </p>
              </div>
            </div>
            <footer class="account-ops account">
              <Button class="swtich-account btn" @click="changePayType">
                {{ letter.plzSelectOtherWay }}
              </Button>
            </footer>
          </article>
        </div>
      </transition>
      <transition name="fade">
        <coupon-confirm-popup
          v-if="isShowCouponConfirmPopup"
          @cancel="isShowCouponConfirmPopup = false"
          @confirm="handleConfirmCoupon"
          :languages="letter"
        ></coupon-confirm-popup>
      </transition>
      <PopupWindow
        @onCancel="showPopup = false"
        @onConfirm="showPopup = false"
        type="tips"
        v-if="showPopup"
        :languages="letter"
        :content="errTips"
      ></PopupWindow>
      <PopupWindow
        @onCancel="handleJump"
        @onConfirm="handleJump"
        type="tips"
        v-if="showBankPopup"
        :languages="letter"
        :content="bankTips"
        class="bank-tip-popup"
      ></PopupWindow>
      <PopupWindow
        @onCancel="handleDoubleSend(false)"
        @onConfirm="handleDoubleSend(true)"
        type="newPopupWindow"
        v-if="showDoubleSendPop"
        :languages="letter"
        :content="doubleSendContent"
        textAlign="center"
      ></PopupWindow>
      <coins-balance-popup
        v-bind:visible.sync="visibleCoinBalancePopup"
      ></coins-balance-popup>
      <transition name="fade">
        <AirWallexBtn
          v-if="airWallexState"
          :airWallexInfo="airWallexInfo"
          :failTips="letter.storeFail"
          @closePopup="cancleAirWalletPopup"
        ></AirWallexBtn>
      </transition>
      <transition name="fade">
        <AreaConfirmPopup
          v-if="showAreaConfirmPopup"
          @hidePopup="cancelAreaConfirmPopup"
          @confirmSwitchArea="confirmSwitchArea"
          :havePayWay="havePayWay"
          @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
        ></AreaConfirmPopup>
      </transition>
      <transition name="fade">
        <ZipCodeConfirmPopup
          v-if="showZipCodeConfirmPopup"
          @handleZipCodeConfirmPopup="handleZipCodeConfirmPopup"
          @confirmZipCodeAndPostOrder="confirmZipCodeAndPostOrder"
          @confirmSwitchArea="confirmSwitchArea"
          :mode="zipCodePopupMode"
        ></ZipCodeConfirmPopup>
      </transition>
      <CommonUidTokenLoginPopup
        v-bind:visible.sync="visibleCommonTokenLoginPopup"
      ></CommonUidTokenLoginPopup>
      <GMOSelectPopup
        ref="GMOSelectPopupRef"
        v-if="showGMOSelectPopup"
        :curPayType="curPayType"
        :postProductDesc="postProductDesc"
        :amountDesc="curCoins.TRANS_AMOUNT"
        :discountTransMount="discountTransMount"
        @hidePopup="showGMOSelectPopup = false"
        @submit="handleGMOSubmit"
        style="z-index: 20"
      ></GMOSelectPopup>
      <PopupWindow
        v-if="visibleInterceptPopup"
        type="tips"
        :languages="letter"
        :title="interceptTitle"
        :content="interceptTip"
        :confirm="interceptConfirm"
        textAlign="center"
        @onConfirm="hideInterceptPopup"
        @onCancel="hideInterceptPopup"
      ></PopupWindow>
    </div>
  </div>
</template>

<script>
import ProductSelecter from '@components/officialTopup/paytype/ProductSelecter';
import PaymentSelecter from '@components/officialTopup/paytype/PaymentSelecter';
import SelectPayWay from '@components/officialTopup/paytype/SelectPayWay';
import AreaConfirmPopup from '@components/officialTopup/paytype/AreaConfirmPopup';
import CommonUidTokenLoginPopup from '@components/officialTopup/login/CommonUidTokenLoginPopup';
import ZipCodeConfirmPopup from '@components/officialTopup/paytype/ZipCodeConfirmPopup';
import LoginInfo from '@components/officialTopup/login/LoginInfo.vue';
import OrderInfo from '@components/officialTopup/paytype/OrderInfo.vue';
import OrderProduct from '@components/officialTopup/paytype/OrderProduct.vue';
import Payment from '@components/officialTopup/paytype/Payment.vue';
import BankPay from '@components/officialTopup/paytype/BankPayway.vue';
import GMOSelectPopup from '@components/officialTopup/paytype/GMOSelectPopup.vue';

import CoinsBalancePopup from '@components/officialTopup/coins/CoinsBalancePopup.vue';
import PointCard, {
  NEED_PIN_ONLY,
  NEED_PIN_SERIAL
} from '@components/officialTopup/paytype/PointCard';
import qs from 'qs';
import bridge from '@utiles/officialStore/bridge';
import {
  STORE_PAGE_BASE_URL,
  RES_HOST,
  FEEKBACK_URL,
  changePriceFormat,
  injectScript,
  minus,
  times,
  getMinItemFromArr,
  couponLocalDateFormat
} from '@utiles/officialStore/index';
import { updateObjScidAndCidOnPwa } from '@utiles/pwa';
import {
  RELOAD_WAY,
  POST_ORDER,
  SET_PAYTYPE,
  UPDATE_LOADING,
  UPDATE_COINS_SUBMIT_TYPE,
  UPDATE_VISIBLE_TOKEN_LOGIN_POPUP,
  MODIFY_THIRD_PARTY_PAYMENT_INFOS,
  SET_GLOBAL_TIPS_VISIBLE,
  UPDATE_ALL_PAYTYPE_PRICE_MAP,
  OPEN_GLOBAL_TIPS
} from '@store/officialTopup';
import {
  SET_PRODUCT_OF_CART,
  UPDATE_SHOW_CARTLIST_STATUS,
  RELOAD_WAY_CART
} from '@store/officialTopup/cart';
import {
  getProductId,
  storeProductId,
  getLocaLclStor,
  getPayTYpeListStore,
  getProductById,
  getDefaultPayType,
  getLastedPayType,
  getServerId,
  getServerName,
  setDefaultPayType,
  getLocationNameByVal,
  getCurLocation,
  setDefaultPrice,
  storeCurLocation,
  getDefaultPrice,
  getStoreHrefParam,
  appendStoreHrefLocation,
  setWebviewPageFlag,
  storeHref,
  getProductByCpId,
  getProductByIdAndRemark,
  getCpProductId,
  storeAreaLimitAutoPopup,
  getAreaLimitAutoPopup
} from '@store/officialTopup/storager';

import {
  GET_BALANCE_INIT_DATA,
  POST_ORDER_JP_COINS,
  GET_BALANCE_USER_DATA
} from '@store/officialTopup/coins';

import {
  UPDATE_JP_CHILD_LIST,
  UPDATE_JP_CHILD_FORM,
  GET_JPSTORE_CHILD_LIST,
  GET_JPSTORE_CHILD_FORM,
  RESET_JPSTORE_GMO_EXTRA_PARAM
} from '@store/officialTopup/jp';

import { b64EncodeUnicode } from '@utiles/officialStore';

import globalConfig from '@utiles/officialStore/globalConfig';
import { getProductDefaultImg } from '@utiles/officialStore/productImg';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import AirWallexBtn from '@components/webStore/AirWallexBtn.vue';

import CouponConfirmPopup from '@components/officialTopup/coupon/CouponConfirmPopup.vue';
import coupon from '@mixins/officialTopup/coupon';
import zipcode from '@mixins/officialTopup/zipcode';
import pay from '@mixins/officialTopup/pay';
import extra from '@mixins/officialTopup/extra';

import { mapState, mapGetters } from 'vuex';
import {
  popupType,
  showPopup,
  clickButton,
  locationType,
  viewPage
} from '@plugins/biPoint/_configWebstoreV3';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import ruProductIntercept from '@mixins/officialTopup/ruProductIntercept';
const AIRWALLEX_FONTS_SRC =
  'https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2';
const AIRWALLEX_JSSDK_URL =
  'https://checkout.airwallex.com/assets/elements.bundle.min.js';
const PAY_REQUEST_GET = 1;
const PAY_REQUEST_POST = 2;
const SHOW_RESULT_PAGE = 5;
const INVOKE_THIRD_JSSDK_FUNCTION = 9;
const PAY_REQUEST_GMO_POST = 6;
const BROWSER_PAY = 11;
const OPEN_BROSWER_METHOD = 'openBrowser';
const mainHost = globalConfig.getMainHost();
const funtapGames = [201, 195];
// todo
// 2021.08.09 白冰：221、263、229游戏采用cpProductId匹配
// 2021.09.18 239使用cpProductId匹配
// 2022.02.16  胡嘉琪:201、255使用cpProductId匹配
// 2022.03.01 白冰：217, 275, 278游戏采用cpProductId匹配
// 2022.03.09 胡嘉琪:279使用cpProductId匹配
// 2022.04.07 胡嘉琪:gameId大于271的新游戏一般都使用productId + cpProductId的匹配方式。特殊游戏使用productId + remark
// 2022.11.25 日本江美接入全球平台
const NEED_CP_ID_GAMES = [
  175, 177, 193, 191, 225, 227, 221, 263, 229, 239, 201, 255, 217, 275, 278,
  279, 281, 2
];
// 2021.06.07 叫我大掌柜越南版、叫我大掌柜全球版第三方商品匹配，使用productID+remark
// 2021.08.06 斗罗3D第三方商品匹配,使用productID+remark
// 2021.10.21 胡嘉琪：越南荣耀大天使商品匹配,使用productID+remark
// 2021.11.18  胡嘉琪:大掌柜韩语日语版商品匹配,使用productID+remark
const NEED_REMARK_GAMES = [183, 215, 213, 251, 261, 209, 211];
// 2022.06.21 区天衡：末日喧嚣pns第三方支付页面新增双倍券弹窗
const ZTMSLG_GAMES = [175, 191, 225, 227, 221, 263, 229, 217, 275, 278, 284];
const LANGUAGE =
  globalConfig.getHrefParam('appLanguage') ||
  globalConfig.getHrefParam('language');

const getStoreAllHrefParam = param => {
  let allHrefParam = getStoreHrefParam();
  return (allHrefParam && allHrefParam[param]) || '';
};

// 判断是否需要通过cpProductId来匹配商品
const checkNeedCpIdMatch = gameId => {
  return NEED_CP_ID_GAMES.includes(+gameId) || +gameId > 271;
};
const isEmptyObj = obj => Object.keys(obj).length === 0;
// 是否使用链接上的remark参数来匹配商品
const checkNeedRemarkMatch = gameId => {
  return NEED_REMARK_GAMES.includes(+gameId);
};

// 初始化当前商品
const initCurProduct = () => {
  let curProductId = getProductId() || getStoreAllHrefParam('productId');
  let gameId = getStoreAllHrefParam('gameId');
  let curProduct = getProductById(curProductId); // 当前商品内容

  //是否需要通过cpProductId来匹配商品
  if (checkNeedCpIdMatch(gameId)) {
    curProduct = getProductByCpId(curProductId);
  }

  // 是否使用链接上的remark参数来匹配商品
  if (checkNeedRemarkMatch(gameId)) {
    let linkRemark = globalConfig.getHrefParam('remark');
    let cpProductId =
      globalConfig.getHrefParam('cpProductId') || getCpProductId();
    let isWeb = 1; // 这里先写死web为1
    if (isWeb && !linkRemark && cpProductId) {
      curProduct = getProductByCpId(curProductId);
    } else {
      curProduct = getProductByIdAndRemark(curProductId, linkRemark);
    }
  }

  return curProduct;
};

// airWallex的apply pay，只能用在safari浏览器上，目前先过滤其他浏览器
const airWallexAppleFilter = list => {
  // 支持苹果支付，才展示所有渠道
  if (
    'ApplePaySession' in window &&
    window?.ApplePaySession?.supportsVersion(4) &&
    window?.ApplePaySession?.canMakePayments()
  ) {
    return list;
  }
  // 不支持苹果支付的，就隐藏苹果渠道
  if (Array.isArray(list) && list.length > 0) {
    return list.filter(
      item => !(item.f_pay_type == 'airwallex' && item.pay_type == 'applepay')
    );
  }
  return [];
};

/*
     支付页面可以无数个入口，但是每个入口必须往sessionStorage 中缓存一下信息：
     地区列表
     当前地区的值（locations name:value 中的value）
     渠道列表
     当前渠道
     价格列表（当前渠道中的priceList）
     当前价格（储值结果页面可能存储了，没有，就显示默认第一个）
     coinName 初始化数据在别的页面加载
     商品列表
     当前商品信息（根据链接上的商品信息，从商品列表中获取）
  */

export default {
  name: 'payPage',
  mixins: [coupon, zipcode, pay, extra, ruProductIntercept],
  props: {
    isCoins: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let curLocationsVal = getCurLocation();
    let curLocationName = getLocationNameByVal(curLocationsVal);

    let defaultPayType = getDefaultPayType();
    let lastPayType = getLastedPayType() || {};
    let allPayTypes = getPayTYpeListStore();
    allPayTypes = airWallexAppleFilter(allPayTypes);
    if (lastPayType.pay_type) {
      for (let k in allPayTypes) {
        if (allPayTypes[k].child && allPayTypes[k].child.length) {
          lastPayType = {};
          break;
        }
      }
    }
    let defaultPrice = getDefaultPrice();
    if (!defaultPrice && Object.keys(defaultPayType).length > 0) {
      defaultPrice = defaultPayType?.price_list?.[0];
    }
    if (defaultPayType.child && defaultPayType.child.length) {
      defaultPayType = Object.assign({}, defaultPayType, {
        selectChildIndex: 0
      });
    }

    // 储值代币，默认选中最小的一个
    let curCoins =
      getMinItemFromArr(defaultPayType.price_list, 'TRANS_AMOUNT') || {};

    return {
      canPost: true,
      showBankPopup: false,
      bankTips: '',
      virtualAccount: '',
      showPayWaySelecter: false,
      showPaymentSelecter: false,
      visibleCoinBalancePopup: false,
      curLocation: curLocationName,
      curLocationVal: curLocationsVal,
      serverId: getStoreAllHrefParam('serverId'),
      serverName: getServerName(),
      roleName: getStoreAllHrefParam('roleName'),
      roleId: getStoreAllHrefParam('roleId'),
      curProduct: this.isCoins ? {} : initCurProduct(),
      curPayType: defaultPayType,
      lastPayType,
      curPrice: defaultPrice || {},
      pricesList: (defaultPayType && defaultPayType.price_list) || [],
      allPayTypes,
      ourServerId: getServerId(),
      postAction: '',
      locations: getLocaLclStor(),
      post_fields: {},
      priceEmpty: false,
      pin: '',
      serial: '',
      showPointCardEditor: false,
      ICON_URI: RES_HOST + 'commonImg/store/',
      showDetail: false,
      isWeb: globalConfig.getHrefParamUndecode('web') === '1',
      showVgmTips: false,
      showProductSelecter: false,
      showErrorPayType: false,
      errTips: '',
      showPopup: false,
      showDoubleSendPop: false, // 双倍券弹窗
      doubleSendState: false, // 是否使用双倍券
      submitLoading: false,
      curCard: {},
      isReload: false,
      curCoinsList: defaultPayType.price_list ? defaultPayType.price_list : [], // 当前选择渠道所可以购买的代金币列表
      curCoins: curCoins, // 当选选中的代金币档位
      airWallexState: false,
      airWallexInfo: {},
      showAreaConfirmPopup: false, // 地区确认弹窗
      visibleCommonTokenLoginPopup: false, // 通用uid登录弹窗
      showZipCodeConfirmPopup: false, // zipcode确认弹窗
      showGMOSelectPopup: false, // GMO渠道选择弹窗
      zipCodePopupMode: '', // zipcode弹窗模式：'order' 提单弹窗需要自动提单
      amazonCheckoutSessionId: '' // 2025-04-07 gmo升级v2需求 保存amazon pay的sessionid
    };
  },
  created() {
    viewPage(locationType.channelPage);
    storeHref();
    this.isCart && this.$store.commit(SET_PAYTYPE, this.curPayType);
    this.checkLocationChange();
  },
  computed: {
    ...mapState({
      isUidLogin: state => state.login.isUidLogin,
      isUidTokenLogin: state => state.login.isUidTokenLogin,
      cartList: state => state.cart.cartList,
      cartQuantityLimit: state => state.cart.cartQuantityLimit,
      hasLoadPaytype: state => state.hasLoadPaytype,
      letter: state => state.letter,
      uid: state => state.login.uid,
      loginType: state => state.login.loginType,
      boolEnoughBalance: state => state.coins.boolEnoughBalance,
      hideSubmit: state => state.hideSubmit,
      coinName: state => state.coinName,
      lang: state => state.lang,
      loginAccount: state => state.login.loginAccount,
      creditCard: state => state.creditCard,
      paypalAgreement: state => state.paypalAgreement,
      clientId: state => state.clientId,
      ipLocation: state => state.ipLocation,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount,
      zipCode: state => state.zipCode,
      ipZipCode: state => state.ipZipCode,
      curTax: state => state.curTax,
      jpChildList: state => state.jp.jpChildList,
      openShoppingCart: state => state.page.openShoppingCart,
      stateCurLocation: state => state.curLocation
    }),
    ...mapGetters([
      'cartTotalQuantity',
      'cartTotalPrice',
      'cartProductType',
      'cartDiscountTransMount',
      'isJpPlatform',
      'getPointPayChannelName',
      'subCoinNama',
      'subCoinIco',
      'extraCoinName',
      'extraCoinIco',
      'isCart'
    ]),
    hideJpAreaSelector() {
      return !this.isJpPlatform;
    },
    gameId() {
      return getStoreAllHrefParam('gameId') || this.$store.state.gameId;
    },
    isFuntapGame() {
      return funtapGames.includes(+this.gameId) && LANGUAGE === 'vi-VN';
    },
    /*
     * 2022.06.21 区天衡：末日喧嚣pns第三方支付页面新增双倍券弹窗
     * 前端判断 remark=SpecialParamWithDoubleSend 则弹窗让玩家选择是否使用双倍卷,选择否，则提单时productRemark=''
     */
    hasDoubleSend() {
      return (
        ZTMSLG_GAMES.indexOf(+this.gameId) !== -1 &&
        this.curProduct.REMARK?.includes?.('SpecialParamWithDoubleSend')
      );
    },
    isBank() {
      return (
        this.curPayType?.f_pay_type === 'virtual_account' &&
        this.curPayType?.pay_type === 'virtual_account'
      );
    },
    doubleSendContent() {
      return this.letter.useDoubleSend.replace(/\n/g, '</br>');
    },
    locaitonSelectable() {
      let selectable = true;
      try {
        selectable = this.$store.state.allLocations.length > 1;
      } catch (e) {}
      return selectable;
    },
    // 这个要再处理一下
    passportLanguages() {
      return this.$store.state.passport.languages;
    },
    iconURL() {
      return (
        RES_HOST +
        'commonImg/store/' +
        this.curPayType.f_pay_type +
        '/' +
        this.curPayType.pay_type +
        '.png'
      );
    },
    childIconURL() {
      let childPayTypeIconName = '';
      try {
        childPayTypeIconName =
          '/' +
          this.curPayType.child[this.curPayType.selectChildIndex].child_id +
          '.png';
      } catch (e) {
        childPayTypeIconName = '.png';
      }
      return `${RES_HOST}commonImg/store/${this.curPayType.f_pay_type}/${this.curPayType.pay_type}${childPayTypeIconName}`;
    },
    childPayTypeName() {
      return this.curPayType.child &&
        this.curPayType.child.length !== 0 &&
        this.curPayType.selectChildIndex !== undefined
        ? this.curPayType.child[this.curPayType.selectChildIndex].child_name
        : '';
    },
    productURL() {
      let url = '';
      if (
        this.curProduct.PRODUCT_ICON != '' &&
        this.curProduct.PRODUCT_ICON != undefined
      ) {
        return this.curProduct.PRODUCT_ICON;
      } else {
        url = getProductDefaultImg(this.curProduct.PRODUCT_TYPE);
      }

      return url;
    },
    totalCount() {
      let count = 0;
      const COIN = this.curProduct.COIN;
      const EXTRA_COIN = this.curProduct.PRODUCT_EXTRA_COIN;
      const currPriceCOIN = this.curPrice.COIN;
      count += this.calCoin(COIN);
      count += this.calCoin(EXTRA_COIN);
      count += this.calCoin(currPriceCOIN);

      return count;
    },
    productCoin() {
      let coin = 0;
      try {
        coin = parseFloat(this.curProduct.COIN) || 0;
      } catch (e) {
        console.warn(e);
      }
      return coin;
    },
    extraCoin() {
      let coin = 0;
      try {
        coin = parseFloat(this.curProduct.PRODUCT_EXTRA_COIN) || 0;
      } catch (e) {
        console.warn(e);
      }
      return coin;
    },
    // 渠道加码
    curPriceExtraCoin() {
      let coin = 0;
      try {
        coin = parseFloat(this.curPrice.EXTRA_COIN) || 0;
      } catch (e) {
        console.warn(e);
      }
      return coin;
    },
    // 渠道拆单游戏币
    curPriceSubCoin() {
      let coin = 0;
      try {
        coin = parseFloat(this.curPrice.SUB_COIN) || 0;
      } catch (e) {
        console.warn(e);
      }
      return coin;
    },
    curPriceCoin() {
      let coin = 0;
      try {
        coin = parseFloat(this.curPrice.COIN) || 0;
      } catch (e) {
        console.warn(e);
      }
      return coin;
    },
    amount() {
      let price = this.curPrice && this.curPrice.IN_APP_TRANS_AMOUNT;
      if (this.curPrice && this.curPrice.CURRENCY === 'VND') {
        price = changePriceFormat(
          this.curPrice.CURRENCY,
          this.curPrice.IN_APP_TRANS_AMOUNT
        );
      }
      return price;
    },
    transMount() {
      let price = this.curPrice && this.curPrice.TRANS_AMOUNT;
      if (this.curPrice && this.curPrice.CURRENCY === 'VND') {
        price = changePriceFormat(
          this.curPrice.CURRENCY,
          this.curPrice.TRANS_AMOUNT
        );
      }
      return price;
    },
    postProductDesc() {
      let desArray = [
        this.curProduct?.CP_PRODUCT_DESC || this.curProduct?.PRODUCT_DESC || ''
      ];
      if (this.extraCoin > 0) {
        // 20240703 运营需求：庄恺杰 特殊处理371ROV替换显示首充赠送水晶道具名称Crystals
        if (+this.gameId === 371) {
          desArray.push(`${this.extraCoin} Crystals`);
        } else if (this.showProductExtraCoinName) {
          desArray.push(`${this.extraCoin} ${this.showProductExtraCoinName}`);
        } else {
          desArray.push(`${this.extraCoin} ${this.coinName}`);
        }
      }
      if (this.curPriceSubCoin > 0) {
        desArray.push(`${this.curPriceSubCoin} ${this.subCoinNama}`);
      }
      if (this.curPriceExtraCoin > 0) {
        desArray.push(`${this.curPriceExtraCoin} ${this.extraCoinName}`);
      }
      return desArray.join(` ${this.letter.and || 'and'} `);
    },
    canSelectMoney() {
      // loginType = 2 | 3时是大R支付，可以选择任意金额储值
      return (
        (!this.isCart && this.curPayType?.fixed == 1) ||
        this?.loginType == 2 ||
        this?.loginType == 3
      );
    },
    discountTransMount() {
      let price = +this.transMount;
      if (!this.paytypeActiveCouponId) {
        return price;
      }
      let isVnPrice = this.curPrice && this.curPrice.CURRENCY === 'VND';
      if (isVnPrice) {
        price = this.curPrice && this.curPrice.TRANS_AMOUNT;
      }
      let newPrice = minus(price, this.activePaytypeCouponReductPrice);
      if (isVnPrice) {
        return changePriceFormat(
          this.curPrice.CURRENCY,
          Number.parseFloat(newPrice).toFixed(2)
        );
      }
      // 如果是日本平台的代币储值使用优惠券，优惠券金额大于商品金额，则显示扣除的代币金额为0
      if (
        this.isJpPlatform &&
        this.curPayType?.f_pay_type === this.getPointPayChannelName &&
        newPrice <= 0
      ) {
        newPrice = 0;
      }
      return newPrice.toFixed(2);
    },
    reductionName() {
      return (
        '-' +
        this.activeCouponInfo.REDUCTION_MONEY +
        this.curPayType.show_currency
      );
    },
    discountName() {
      return times(this.activeCouponInfo.DISCOUNT, 100) + '%OFF';
    },
    haveChangeAreaTimes() {
      return (
        this.maxLocationModifyCount &&
        this.locationModifyCount < this.maxLocationModifyCount
      );
    },
    havePayWay() {
      return this.locations?.some(item => item.value === this.curLocationVal);
    },
    submitOrderBtnText() {
      if (
        this.curPayType &&
        this.curPayType.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.isJpPlatform
          ? this.letter.jpUidLoginName
          : this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    },
    isShowTax() {
      return +this.curTax > 0 && this.curLocationVal === 'US';
    },
    realCartTotalPrice() {
      const showPrice =
        this.cartTotalPrice +
        (this.isShowTax ? +this.curTax : 0) -
        this.activePaytypeCouponReductPrice;
      if (this.curPrice && this.curPrice.CURRENCY === 'VND') {
        const vnPrice = changePriceFormat(
          this.curPrice.CURRENCY,
          showPrice.toString()
        );
        return vnPrice;
      }
      return showPrice.toFixed(2);
    },
    realTotalPrice() {
      let price = this.curPrice?.TRANS_AMOUNT || 0;
      const showPrice =
        +price +
        (this.isShowTax ? +this.curTax : 0) -
        this.activePaytypeCouponReductPrice;
      if (this.curPrice && this.curPrice.CURRENCY === 'VND') {
        const vnPrice = changePriceFormat(
          this.curPrice.CURRENCY,
          showPrice.toString()
        );
        return vnPrice;
      }
      return showPrice.toFixed(2);
    },
    // 2025-04-07 gmo升级v2需求 是否需要先获取gmo的amazon pay渠道的支付窗口sessionid
    isGMOAmazonPayLoginBtn() {
      return this.isGMOAmazonPay && !this.amazonCheckoutSessionId;
    },
    // 2025-04-07 gmo升级v2需求 是否是gmo的amazon pay渠道
    isGMOAmazonPay() {
      return (
        this.curPayType?.f_pay_type === 'gmo' &&
        this.curPayType?.pay_type === 'amazon_pay'
      );
    }
  },
  directives: {
    fixing: {
      // 自定义指令, 作用：底部超长适配
      update: function () {
        try {
          const maxWidth = 640;
          const changeLineWidth = 520;
          const detailEle =
            document.getElementsByClassName('order-detail-info')[0];
          const detailWrap =
            document.getElementsByClassName('detail-container')[0];
          const detailWidth = detailEle.getBoundingClientRect().width;
          // 换行
          if (detailWidth > changeLineWidth) {
            detailWrap.classList.add('Prefix');
          }
          // 换行还是不够,缩小字体
          if (detailWidth > maxWidth) {
            detailEle.classList.add('scale');
          }
        } catch {}
      }
    }
  },
  watch: {
    curPayType(newVal, oldVal) {
      if (newVal?.name) {
        this.showVgmTips =
          ['mobifone card', 'vinaphone card', 'viettel card '].indexOf(
            newVal.name
          ) !== -1;
      }
      if (newVal?.price_list) {
        this.curCoins =
          getMinItemFromArr(newVal.price_list, 'TRANS_AMOUNT') || {};
      }
      // 2025-04-07 gmo升级v2需求 渠道变更，需要重置gmo的amazonpay的sessionid
      if (
        newVal?.f_pay_type !== oldVal?.f_pay_type ||
        newVal?.pay_type !== oldVal?.pay_type
      ) {
        this.amazonCheckoutSessionId = '';
      }
    },
    allPayTypes: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.isCart && newVal && newVal.length) {
          let info = [];
          newVal.forEach(item => {
            let priceList = [];
            item.price_list &&
              item.price_list.length &&
              item.price_list.forEach(pItem => {
                if (pItem.AMOUNT_LEVEL_LIST && pItem.AMOUNT_LEVEL_LIST.length) {
                  priceList = priceList.concat(pItem.AMOUNT_LEVEL_LIST);
                }
              });
            info.push({
              f_pay_type: item.f_pay_type,
              pay_type: item.pay_type,
              priceList: priceList
            });
          });
          this.$store.commit(UPDATE_ALL_PAYTYPE_PRICE_MAP, info);
        }
      }
    },
    cartTotalPrice() {
      if (this.hasLoadPaytype && this.cartTotalPrice > 0) {
        this.changeCouponList();
      }
    },
    isUidTokenLogin(newVal) {
      // uid登录选择代币储值需要uid登录，登录成功重新加载渠道
      newVal && this.reloadWay();
    },
    // 2025-04-07 gmo升级v2需求 监听gmo的amazon pay渠道的支付窗口的回调sessionid
    isGMOAmazonPayLoginBtn(newVal) {
      if (newVal) {
        window.addEventListener(
          'message',
          this.updateGMOAmazonPaySessionMessage
        );
      } else {
        window.removeEventListener(
          'message',
          this.updateGMOAmazonPaySessionMessage
        );
      }
    }
  },
  methods: {
    updateCurCoins(curCoins) {
      this.curCoins = curCoins;
    },
    handleConfirmCoupon() {
      this.isShowCouponConfirmPopup = false;
      this.hasConfirmCoupon = true;
      this.postOrder();
    },
    // 处理双倍券
    handleDoubleSend(state) {
      this.doubleSendState = state;
      this.showDoubleSendPop = false;
      commonEmitUpload(
        'useDoubleSend',
        {
          event: 'useDoubleSend',
          type: 'click',
          pageName: 'pay-page'
        },
        state ? '使用双倍券' : '不使用双倍券'
      );
      this.beforeDoPostOrder();
    },
    // 更换支付渠道
    changePayType() {
      this.showErrorPayType = false;
      this.$nextTick(() => {
        this.showPayWaySelecter = true;
      });
    },
    // 更改商品
    changeProduct() {
      this.showProductSelecter = true;
      showPopup(popupType.productPopup);
    },
    handleSelectProduct(product) {
      this.curProduct = product;
      storeProductId(product.PRODUCT_ID);
      this.reloadWay('product');
    },
    reloadWay(type) {
      if (!this.isCoins && !this.isCart && !this.curProduct.PRODUCT_ID) {
        this.changeProduct();
        return;
      }
      let params = {
        location: this.curLocationVal,
        productId: !this.isCart ? this.curProduct.PRODUCT_ID : ''
      };
      this.$store.commit(UPDATE_LOADING, true);
      this.isReload = true;
      const reloadAction = {
        cart: RELOAD_WAY_CART,
        notcart: RELOAD_WAY,
        coins: GET_BALANCE_INIT_DATA
      };
      let action = '';
      if (this.isCoins) {
        action = 'coins';
      } else {
        action = this.isCart ? 'cart' : 'notcart';
      }
      this.$store
        .dispatch(reloadAction[action], params)
        .then(success => {
          if (success) {
            // 如果是代币储值则在切换地区后更新余额
            this.isCoins && this.$store.dispatch(GET_BALANCE_USER_DATA);
            let defaultPayType = getDefaultPayType();
            let allPayTypes = getPayTYpeListStore();
            allPayTypes = airWallexAppleFilter(allPayTypes);
            allPayTypes = allPayTypes.filter(item => item?.price_list?.length);
            let payType = defaultPayType?.price_list?.length
              ? defaultPayType
              : allPayTypes[0];
            if (type === 'product') {
              let hasCurPayType = allPayTypes.find(
                item =>
                  item?.f_pay_type === this.curPayType?.f_pay_type &&
                  item?.pay_type === this.curPayType?.pay_type &&
                  item?.currency === this.curPayType?.currency &&
                  item?.show_currency === this.curPayType?.show_currency &&
                  item?.price_list?.length
              );
              if (!hasCurPayType) {
                this.showErrorPayType = true;
                showPopup(popupType.errorPaytypePopup);
              }
              if (hasCurPayType) {
                if (
                  this.curPayType.selectChildIndex ||
                  this.curPayType.selectChildIndex === 0
                ) {
                  hasCurPayType.selectChildIndex =
                    this.curPayType.selectChildIndex;
                }
                payType = hasCurPayType;
                // 保存当前储值渠道
                setDefaultPayType(hasCurPayType);
              }
            }
            // 保存当前地区
            storeCurLocation(this.curLocationVal);
            this.curPayType = payType;
            this.curPrice = payType?.price_list?.[0];
            this.pricesList = payType?.price_list;
            this.allPayTypes = allPayTypes;
            this.$store.commit(UPDATE_LOADING, false);
            this.resetCurCard();
          }
        })
        .catch(errmsg => {
          this.$store.commit(UPDATE_LOADING, false);
          this.errTips = errmsg;
          this.showPopup = true;
        });
    },
    showFeebackPage() {
      // 判断是否web端页面，如果是，跳到web端的临时工单页
      if (globalConfig.getHrefParamUndecode('web') === '1') {
        window.open(`https://service.${mainHost}` + window.location.search);
      } else {
        bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
          url: FEEKBACK_URL,
          loginDir: 1,
          appendParams: 1
        });
      }
    },
    selectPayMent(payment) {
      this.showPaymentSelecter = false;
      this.curPrice = payment;
      this.changeCouponList();
    },
    getNowBuyType() {
      if (this.isCart) {
        return 'add_to_cart';
      }
      return 'buy_now';
    },
    selectPayType(payType) {
      this.showPayWaySelecter = false;
      this.isCart &&
        this.$store.commit(SET_PAYTYPE, Object.assign({}, payType));
      this.curPayType = Object.assign({}, payType);
      this.pricesList = payType.price_list;
      this.curPrice = payType.price_list[0];
      this.resetCurCard();
      this.changeCouponList();
      this.changeCurCoinsList(payType);
      this.sendSelectPaytypeData();
    },
    sendSelectPaytypeData() {
      window.webstorev3DataLayer.push({
        eventName: 'select_channels',
        eventType: this.getNowBuyType(),
        eventReason: this.curPayType?.isAutoSelect
          ? 'auto_select'
          : 'click_select',
        eventValue: {
          f_pay_type: this.curPayType.f_pay_type,
          pay_type: this.curPayType.pay_type
        }
      });
    },
    changeCurCoinsList(payType) {
      this.curCoinsList =
        payType && payType.price_list ? payType.price_list : [];
    },
    selectCard(card) {
      this.curCard = card;
    },
    closePointCardEditor() {
      this.showPointCardEditor = false;
    },
    payWidthPointCard({ pin, serial }) {
      this.showPointCardEditor = false;
      this.pin = pin;
      this.serial = serial;
      this.doPostORder();
    },
    getActiveCouponTagText(couponInfo) {
      if (couponInfo?.DESCRIPTION) {
        return couponInfo?.DESCRIPTION;
      }
      if (+couponInfo.TYPE === 0) {
        return this.letter.couponReductionType;
      }
      if (+couponInfo.TYPE === 1) {
        return this.letter.couponDiscountType;
      }
      return '';
    },
    getActiveCouponBiData() {
      const is_coupon = this.paytypeActiveCouponId ? 1 : 0;
      let couponInfo = this.activePaytypeCouponInfo;
      return {
        is_coupon,
        coupon_typeid: is_coupon ? couponInfo?.COUPON_TYPE : '',
        coupon_type_name: is_coupon
          ? this.getActiveCouponTagText(couponInfo)
          : '',
        coupon_id: is_coupon ? couponInfo?.COUPON_ID : '',
        coupon_start_time: is_coupon ? couponInfo?.GET_TIME : '',
        coupon_end_time: is_coupon ? couponInfo?.EXPIRY_TIME : '',
        coupon_local_money: is_coupon ? couponInfo?.REDUCTION_MONEY : '',
        coupon_discount: is_coupon ? couponInfo?.DISCOUNT : ''
      };
    },
    sendSubmitBiData() {
      let params = {
        product_type: this.curProduct.PRODUCT_TYPE || '',
        cp_product_id: this.curProduct.CP_PRODUCT_ID || '',
        product_id: this.curProduct?.PRODUCT_ID || '',
        product_list: '',
        product_num: '1',
        product_currency: this.curPrice?.CURRENCY || '',
        product_money: this.curPrice.TRANS_AMOUNT || '',
        local_currency: this.curPrice?.CURRENCY || '',
        local_money: this.curPrice.TRANS_AMOUNT || '',
        f_pay_type: this.curPayType?.f_pay_type || '',
        pay_type: this.curPayType?.pay_type || '',
        ...this.getActiveCouponBiData()
      };
      if (this.isCoins) {
        Object.assign(params, {
          product_type: '',
          cp_product_id: '',
          product_id: '',
          product_currency: this.curCoins.CURRENCY,
          product_money: this.curCoins.TRANS_AMOUNT || '',
          local_currency: this.curCoins.CURRENCY,
          local_money: this.curCoins.TRANS_AMOUNT || ''
        });
      }

      if (this.isCart) {
        Object.assign(params, {
          product_type: this.cartProductType,
          cp_product_id: '',
          product_id: '',
          product_list: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          product_num: this.cartList.length,
          product_currency: this.$store.state.paytype.currency,
          product_money: this.cartTotalPrice,
          local_currency: this.$store.state.paytype.currency,
          local_money: this.cartTotalPrice
        });
      }
      window.webstorev3DataLayer.push({
        eventName: 'select_submit',
        eventType: this.getNowBuyType(),
        eventValue: params
      });
    },
    bankPostOrder() {
      // PNS针对俄罗斯ip玩家拦截指定商品id的购买
      if (!this.handleProductIntercept(this.curProduct)) {
        return;
      }
      if (isEmptyObj(this.isCoins ? this.curCoins : this.curPrice)) {
        this.showCreateFaileTips('請選擇匯款金額');
        return;
      }
      if (!this.canPost) {
        return;
      }
      commonEmitUpload('click-submit-btn-manual', {
        event: 'click-submit-btn-manual',
        newPage: true,
        type: 'click'
      });
      this.canPost = false;
      const params = {
        f_pay_type: this.curPayType?.f_pay_type,
        paytype: this.curPayType?.pay_type,
        gameId: this.gameId,
        serverId: this.ourServerId,
        currency: this.curPayType?.currency,
        roleId: this.roleId,
        roleName: this.roleName,
        ptCode: 'global', // 区分新旧提单
        zipCode: this.zipCode,
        cid: globalConfig.getHrefParamUndecode('cid') || '',
        scid: globalConfig.getHrefParamUndecode('scid') || ''
      };
      this.isCoins &&
        Object.assign(params, {
          submitType: 2
        });
      this.$store
        .dispatch(POST_ORDER, params)
        .then(res => {
          this.canPost = true;
          this.showBankPopup = true;
          this.bankTips =
            '發票處理事宜：於匯款完成七日內，請至下方『操作說明』選擇發票處理方式，若逾期未選擇，發票將默認捐贈“社團法人台灣偵搜犬協會”不做他用。';
          this.virtualAccount = res.data.virtual_account_info.virtual_account;
        })
        .catch(err => {
          this.canPost = true;
          this.showCreateFaileTips(err.errmsg);
        });
    },
    handleJump() {
      this.showBankPopup = false;
      this.$router.push({
        name: 'bankInfo',
        query: {
          amount: this.curPrice?.TRANS_AMOUNT,
          account: this.virtualAccount
        }
      });
    },
    async postOrder() {
      if (!this.curPayType || this.curPayType == 'undefined') {
        return;
      }
      if (this.isGMOAmazonPayLoginBtn) {
        // 外跳打开gmo的amazon pay的登录页面
        window.open(
          `https://jpstore.${window.atob('MzdnYW1lcy5jb20=')}/amazon-pay.html`,
          '_blank'
        );
        return;
      }
      if (this.isBank) {
        this.bankPostOrder();
        return;
      }
      // 如果绑定美国校验，zipcode不合规弹出弹窗
      if (this.curLocationVal === 'US') {
        const isZipCodeValid = await this.isZipCodeValidFunc(this.zipCode);
        if (!isZipCodeValid) {
          this.handleZipCodeConfirmPopup(true);
          this.zipCodePopupMode = 'order';
          return;
        }
      }
      this.sendSubmitBiData();
      // 代币消费：接口返回的的父渠道f_pay_type和子渠道pay_type在全球叫：user_balance_pay；在日本叫points_pay
      let coinsPayName = this.getPointPayChannelName;
      // 判断代币支付时是否是非UID登录
      if (
        !this.isCoins &&
        this.curPayType.f_pay_type === coinsPayName &&
        this.curPayType.pay_type === coinsPayName &&
        this.isUidLogin
      ) {
        this.$store.commit(UPDATE_VISIBLE_TOKEN_LOGIN_POPUP, true);
        return;
      }
      // 判断是否足够代币支付
      if (
        !this.isCoins &&
        !this.boolEnoughBalance &&
        this.curPayType.f_pay_type === coinsPayName &&
        this.curPayType.pay_type === coinsPayName
      ) {
        this.visibleCoinBalancePopup = true;
        showPopup(popupType.coinBalancePopup);
        return;
      }

      // 选择了优惠券，则弹优惠券确认弹窗
      if (this.paytypeActiveCouponId && !this.hasConfirmCoupon) {
        this.isShowCouponConfirmPopup = true;
        showPopup(popupType.couponUseCheckPopup);
        // this.$clearDisable()
        return;
      }

      /* 如果展示双倍券弹窗，则提单doPostORder函数的调用交由弹窗处理*/
      if (this.hasDoubleSend) {
        this.showDoubleSendPop = true;
        showPopup(popupType.doubleSendPopup);
        return;
      }
      const boolDirectPost = this.beforeDoPostOrder();
      boolDirectPost &&
        commonEmitUpload('click-submit-btn-manual', {
          event: 'click-submit-btn-manual',
          newPage: true,
          type: 'click'
        });
    },

    async loadJpChildChannel() {
      this.$store.commit(UPDATE_JP_CHILD_LIST, []);
      this.$store.commit(UPDATE_JP_CHILD_FORM, {});
      return new Promise(resolve => {
        this.$store
          .dispatch(GET_JPSTORE_CHILD_LIST, {
            fType: this.curPayType?.f_pay_type,
            pay_type: this.curPayType?.pay_type
          })
          .then(async res => {
            if (res.length === 0) {
              await this.$store.dispatch(GET_JPSTORE_CHILD_FORM, {
                fType: this.curPayType?.f_pay_type,
                pay_type: this.curPayType?.pay_type,
                child_id: ''
              });
              resolve();
            } else {
              resolve();
            }
          });
      });
    },

    async beforeDoPostOrder() {
      // PNS针对俄罗斯ip玩家拦截指定商品id的购买
      if (!this.handleProductIntercept(this.curProduct)) {
        return;
      }
      // 日本平台gmo渠道先检查子渠道和子渠道需要填写的表单
      if (this.isJpPlatform && this.curPayType?.f_pay_type === 'gmo') {
        // 2025-04-08 调整接口loadJpChildChannel的请求位置：仅便利店渠道请求。避免导致其他gmo渠道新开页面时会被浏览器拦截
        if (
          this.curPayType?.pay_type === 'convenience' ||
          this.curPayType?.pay_type === 'edy'
        ) {
          await this.loadJpChildChannel();
          this.showGMOSelectPopup = true;
          return;
        }
        this.doPostORder();
        return;
      }

      if (
        this.curPayType.type == NEED_PIN_ONLY ||
        this.curPayType.type == NEED_PIN_SERIAL
      ) {
        this.showPointCardEditor = true;
        showPopup(popupType.pointCardPopup);
        return false;
      } else {
        this.doPostORder();
        return true;
      }
    },

    getPayOrderParam(allHrefParam) {
      if (!allHrefParam) {
        allHrefParam = {};
      }
      let allCurLinkParams = globalConfig.getAllUrlParamsObj();
      let params = Object.assign(allCurLinkParams, allHrefParam, {
        productId: this.curProduct.PRODUCT_ID,
        cpProductId: this.curProduct.CP_PRODUCT_ID,
        f_pay_type: this.curPayType.f_pay_type,
        location: this.curLocationVal || this.stateCurLocation, // store内的stateCurLocation做sessionStorage失效的兜底
        paytype: this.curPayType.pay_type,
        amount: this.curPrice.TRANS_AMOUNT,
        currency: this.curPrice.CURRENCY,
        amountDesc: this.curPrice.TRANS_AMOUNT,
        productDesc: this.postProductDesc,
        serverId: this.ourServerId,
        pin: this.pin,
        serial: this.serial,
        curReferer: location.hostname,
        // 后端需要的商品remark
        // 2022/06/21 白冰：针对末日，双倍券弹窗下，当玩家选择否，则productRemark传空字符串
        // productRemark的值会影响到部分游戏商品发货，末日针对双倍券特殊处理，其它游戏依旧传REMARK的值！
        productRemark: this.hasDoubleSend
          ? this.doubleSendState
            ? this.curProduct.REMARK
            : ''
          : this.curProduct.REMARK,

        // 传输sdk的remark参数
        sdkRemark: allHrefParam.remark,
        // 用于结果页判断是否web端页面，修改一些按钮的显示隐藏和跳转地址
        // isWeb: globalConfig.getHrefParamUndecode('web'),
        // 二期才会考虑在webview内，先写死web
        isWeb: 1,
        // 用于结果页判断来源
        pageSource: globalConfig.getHrefParamUndecode('pageSource'),
        // H5游戏储值推送给统计的参数：cid,scid
        cid: globalConfig.getHrefParamUndecode('cid') || '',
        scid: globalConfig.getHrefParamUndecode('scid') || '',
        hideService: globalConfig.getHrefParamUndecode('hideService') || '',
        //选中渠道中的信用卡的KEY_VALUE
        keyValue: this.curCard.KEY_VALUE || '',
        // 结果页面地址
        redirectPath: '/platform/officialTopup.html',
        uid: this.uid,
        isUidLogin: this.isUidLogin ? '1' : '0',
        ptCode: 'global', // 区分新旧提单
        cpProductExt: b64EncodeUnicode(
          JSON.stringify(this.curProduct.CP_PRODUCT_EXT || {})
        ),
        productType: this.curProduct.PRODUCT_TYPE || '',
        couponId: this.paytypeActiveCouponId || '',
        couponInfoName: this.submitCouponInfoName,
        discountAfterAmount: this.paytypeActiveCouponId
          ? this.discountTransMount + ' ' + this.curPayType.show_currency
          : '',
        biCouponInfo: this.getActiveCouponBiData(),
        loginAccount: this.loginAccount || '',
        buyType: this.getNowBuyType(),
        clientId: this.clientId,
        priceSubCoinName: this.subCoinNama, // 渠道拆单道具名称
        priceExtraCoinName: this.extraCoinName, // 渠道加码道具名称
        productExtraCoin: this.curProduct?.PRODUCT_EXTRA_COIN || 0, // 开发商加码PRODUCT_EXTRA_COIN
        productExtraCoinName: this.coin_name, // 开发商加码道具名称
        zipCode: this.zipCode,
        ipZipCode: this.ipZipCode,
        curTax: this.curTax,
        cpSign: this?.curProduct?.CP_SIGN || '',
        // 透传是否是PWA避免到了结果页后点击继续储值没了PWA标识
        mode: globalConfig.getHrefParamUndecode('mode') || '',
        apps: globalConfig.getHrefParamUndecode('appsFlyerId') || '',
        ...getGlobalGetLinkParams()
      });
      params = updateObjScidAndCidOnPwa(params);
      if (this.isCoins) {
        params = Object.assign({}, params, {
          submitType: 2,
          productId: '',
          cpProductId: '',
          productType: '',
          productDesc: `${this.curCoins.TRANS_AMOUNT} ${this.curCoins.SHOW_CURRENCY}`,
          cpProductExt: '',
          couponId: '',
          couponInfoName: '',
          discountAfterAmount: '',
          amount: this.curCoins.TRANS_AMOUNT,
          amountDesc: this.curCoins.TRANS_AMOUNT,
          currency: this.curCoins.CURRENCY,
          serverId: this.$store.state.serverId,
          roleId: this.$store.state.roleId,
          roleName: this.$store.state.roleName
        });
        this.isJpPlatform && (params.flowType = '1');
      }

      if (this.isCart) {
        params = Object.assign({}, params, {
          productId: '',
          cpProductId: '',
          remark: '',
          sdkRemark: '',
          productRemark: '',
          amount: this.cartTotalPrice,
          submitType: 1,
          productList: b64EncodeUnicode(
            JSON.stringify(this.getCartListParam())
          ),
          currency: this.$store.state.paytype.currency,
          productDesc: this.letter.total_n_product.replace(
            '${n}',
            this.cartTotalQuantity
          ),
          cpProductExt: '',
          productType: this.cartProductType,
          couponId: this.paytypeActiveCouponId || '',
          couponInfoName: this.submitCouponInfoName,
          discountAfterAmount: this.paytypeActiveCouponId
            ? this.cartDiscountTransMount + ' ' + this.curPayType.show_currency
            : ''
        });
      }
      if (this.curPayType.child && this.curPayType.child.length) {
        params = Object.assign(
          {},
          params,
          this.curPayType.child[this.curPayType.selectChildIndex]
        );
      }
      if (this.curPayType.f_pay_type === 'credit_card') {
        params = Object.assign({}, params, {
          cardScheme: this.creditCard || '' // 信用卡类型
        });
      }
      // agreements,父渠道为paypal_api，子渠道为paypal_agreement时必传，1为开启协议支付
      if (
        this.curPayType.f_pay_type === 'paypal_api' &&
        this.curPayType.pay_type === 'paypal_agreement'
      ) {
        params = Object.assign({}, params, {
          agreements: +this.paypalAgreement
        });
      }
      // 如果是gmo的amazon pay渠道，还要补上
      if (this.isGMOAmazonPay) {
        params['amazonCheckoutSessionId'] = this.amazonCheckoutSessionId;
      }
      return params;
    },

    getCartListParam() {
      return this.cartList.map(item => {
        return {
          productId: item.PRODUCT_ID,
          cpProductId: item.CP_PRODUCT_ID,
          remark: item.REMARK || '',
          amount: item.amountLevel.TRANS_AMOUNT || '',
          quantity: item.quantity,
          productDesc: item?.CP_PRODUCT_DESC || item?.PRODUCT_DESC || '',
          cpProductExt: item.CP_PRODUCT_EXT || {},
          cpSign: item?.CP_SIGN || ''
        };
      });
    },

    redirectToPay(data) {
      const redirect_url = data.redirect_url;
      location.href = redirect_url;
    },

    postByForm(data) {
      this.postAction = data.redirect_url;
      this.post_fields = data.post_fields;
      this.$nextTick(() => {
        document.querySelector('#postOrderToBank').click();
      });
    },

    showPayResult(params, allHrefParam, result, data) {
      let timmap = new Date().getTime();
      let encodeParamStr = window.b64EncodeUnicode(JSON.stringify(params));
      let patam = {
        result,
        msg: result.msg,
        game_id: allHrefParam.gameId,
        game_name: allHrefParam.gameName,
        server_id: this.ourServerId,
        server_sid: allHrefParam.serverId,
        order_id: data.order_id,
        exchange_timestamp: timmap,
        hideService: allHrefParam.hideService,
        store_url_params: encodeParamStr
      };
      let pasrams = qs.stringify(patam);
      let href = STORE_PAGE_BASE_URL + pasrams + '#/result';
      location.href = href;
    },

    invokeThirdJssdkFunc(data, injectConfig = {}) {
      if (data && data.payment_intent) {
        let airwallexConfig = data.payment_intent;
        let env = airwallexConfig.env;
        airwallexConfig.theme = {
          // Must provide theme to display the checkout page properly
          fonts: [
            // Customizes the font for the payment elements
            {
              src: AIRWALLEX_FONTS_SRC,
              family: 'AxLLCircular',
              weight: 400
            }
          ]
        };
        // 注入airwallex jssdk
        injectScript(AIRWALLEX_JSSDK_URL, function () {
          try {
            // 初始化Airwallex
            Airwallex.init({
              env: env, // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
              origin: window.location.origin // Setup your event target to receive the browser events message
            });
            let curInfo = {
              ...airwallexConfig,
              ...injectConfig
            };
            console.log(curInfo);
            // 生成Airwallex订单
            let href = Airwallex.redirectToCheckout(curInfo);
            if (curInfo.disableAutoRedirect) {
              if (href) {
                bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
                  url: href,
                  loginDir: 0,
                  appendParams: 0
                });
              }
            }
          } catch (error) {
            console.error('There was an loading error', error);
          }
        });
      }
    },

    openBrowserToPay(data) {
      const redirect_url = data.redirect_url;
      if (bridge.runInsdk()) {
        bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
          url: redirect_url,
          loginDir: 0,
          appendParams: 0
        });
        this.$router.push('browserPay');
      } else {
        location.href = redirect_url;
      }
    },

    doPostORder() {
      let allHrefParam = getStoreHrefParam();
      if (undefined == this.curPrice) {
        this.priceEmpty = true;
        return;
      }
      if (
        !this.isCoins &&
        !this.isCart &&
        !this.curProduct.PRODUCT_ID &&
        !this.curProduct.CP_PRODUCT_ID
      ) {
        this.changeProduct();
        return;
      }
      if (
        this.curPayType.child &&
        this.curPayType.child.length &&
        this.curPayType.selectChildIndex === undefined
      ) {
        this.changePayType(allHrefParam);
        return;
      }
      if (this.isCart) {
        if (this.cartList.length === 0) {
          this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.cart_is_empty_tip);
          return;
        }

        if (this.cartTotalQuantity > this.cartQuantityLimit) {
          this.$store.commit(
            OPEN_GLOBAL_TIPS,
            `${this.letter.limit_order.replace('${n}', this.cartQuantityLimit)}`
          );
          return;
        }
      }
      // 如果是credit_card类型且没有选择信用卡，则阻止提单
      if (this.curPayType.f_pay_type === 'credit_card') {
        if (!this.creditCard || !this.creditCard.length) {
          this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.storeFailTips);
          return;
        }
      }
      this.submitLoading = true;
      this.$store.commit(UPDATE_LOADING, true);
      let params = this.getPayOrderParam(allHrefParam);
      let actionName = POST_ORDER;
      // 日本的代币储值和商品储值提单是不同的接口，而全球是同一个接口
      if (
        this.isJpPlatform &&
        this.curPayType.f_pay_type === this.getPointPayChannelName &&
        this.curPayType.pay_type === this.getPointPayChannelName
      ) {
        actionName = POST_ORDER_JP_COINS;
      }
      let myWin = null;
      if (this.isJpPlatform && this.curPayType.f_pay_type == 'gmo') {
        const hostName = window.location.hostname;
        const firstHost = hostName.split('.')[0];
        //全球平台日本平台域名兼容
        if (firstHost === 'pay') {
          myWin = window.open(
            `${window.location.origin}/platform/loading.html`,
            '_blank'
          );
        } else {
          myWin = window.open(
            `${window.location.origin}/loading.html`,
            '_blank'
          );
        }
        // 仅便利店的GMO渠道需要传入额外的参数（走接口获取的动态表单）
        if (
          this.curPayType?.pay_type === 'convenience' ||
          this.curPayType?.pay_type === 'edy'
        ) {
          Object.assign(params, this.$store.state.jp.jpStoreGmoExtraParam);
          this.$store.commit(RESET_JPSTORE_GMO_EXTRA_PARAM);
        }
      }

      this.$store
        .dispatch(actionName, params)
        .then(response => {
          let { data, result } = response;
          storeCurLocation(this.curLocationVal);
          setDefaultPrice(this.curPrice);
          setDefaultPayType(this.curPayType);
          appendStoreHrefLocation(this.curLocationVal);
          setWebviewPageFlag();
          // this.$clearDisable()
          // return;
          if (+result !== 1) {
            myWin && myWin?.close();
          }
          switch (Number(data.type)) {
            // type=1 GET方式跳转
            case PAY_REQUEST_GET:
              this.redirectToPay(data, params);
              break;
            // type=2 需要构造一个FORM表单 POST跳转
            case PAY_REQUEST_POST:
              if (this.isJpPlatform && this.curPayType.f_pay_type == 'gmo') {
                myWin.postMessage(data, origin);
                this.changeCouponList();
              } else {
                this.postByForm(data);
              }
              break;
            // type=5 直接在页面显示充值成功
            case SHOW_RESULT_PAGE:
              this.showPayResult(params, allHrefParam, result, data);
              break;
            // type=9 调用第三方JSSDK方法，AIRWALLEX渠道使用
            case INVOKE_THIRD_JSSDK_FUNCTION: {
              let nowFPayType = this.curPayType.f_pay_type || '';
              let nowPayType = this.curPayType.pay_type || '';
              const resFPayType = data?.f_pay_type || '';
              const resPayType = data?.pay_type || '';
              // 路由渠道的airwallex，需要根据返回的f_pay_type和pay_type来判断
              if (nowFPayType == 'router' && resFPayType && resPayType) {
                nowFPayType = resFPayType;
                nowPayType = resPayType;
              }
              let methods = ['card'];
              if (nowFPayType == 'airwallex') {
                methods = [nowPayType];
                if (nowPayType == 'airwallex_kr') {
                  methods = ['card', 'kakaopay'];
                }
                if (nowPayType == 'airwallex') {
                  methods = ['card'];
                }
              }
              // 如果是webview里面的googlepay，要用外跳的方式。
              // 因为安卓的webview不支持这种googlepay按钮，而苹果的因为我们的包webivew类型问题无法打开（测试的时候发现WKWebView打不开，但是SFSafariViewController 可以）
              if (
                nowFPayType == 'airwallex' &&
                nowPayType == 'googlepay' &&
                bridge.runInsdk()
              ) {
                this.invokeThirdJssdkFunc(data, {
                  disableAutoRedirect: true,
                  googlePayRequestOptions: {
                    emailRequired: true,
                    billingAddressParameters: {
                      format: 'FULL',
                      phoneNumberRequired: true
                    },
                    billingAddressRequired: true
                  },
                  methods
                });
                break;
              }
              // 这两个渠道使用按钮的方式拉起原生
              if (
                nowFPayType == 'airwallex' &&
                (nowPayType == 'googlepay' || nowPayType == 'applepay')
              ) {
                this.airWallexInfo = data.payment_intent;
                this.airWallexInfo['pay_type'] = nowPayType;
                this.airWallexInfo['location'] = this.curLocationVal;
                this.airWallexState = true;
                let point =
                  nowPayType == 'googlepay' ? 'googlepay支付' : 'Apple Pay支付';
                this.airWallexInfo['point_name'] = point;
                showPopup(`展示${point}`);
                break;
              }
              this.invokeThirdJssdkFunc(data, {
                methods
              });
              break;
            }
            case BROWSER_PAY:
              // type=11 打开浏览器储值
              this.openBrowserToPay(data);
              break;
            case PAY_REQUEST_GMO_POST:
              // type=6 处理GMO的POST请求展示结果
              if (data.errors) {
                myWin.close();
                this.showCreateFaileTips(data.errors[0]);
              } else {
                let _url = `https://jpstore.${window.atob(
                  'MzdnYW1lcy5jb20='
                )}/html/h5GMOPayResult.html?result=1&gameId=${
                  this.gameId
                }&serverId=${this.ourServerId}&roleId=${
                  this.$store.state.roleId
                }&roleName=${encodeURIComponent(
                  this.$store.state.roleName
                )}&userName=${this.loginAccount}&type=${
                  this.curPayType.pay_type
                }&msg=${encodeURIComponent(JSON.stringify(data.show))}`;
                myWin.location.href = window.globalGetGotoLink({
                  link: _url
                });
                this.showGMOSelectPopup = false;
                this.changeCouponList();
                break;
              }
          }
          this.submitLoading = false;
          this.$store.commit(UPDATE_COINS_SUBMIT_TYPE, this.isCoins);
          this.$store.commit(UPDATE_LOADING, false);
          // 2025-04-07 gmo升级v2需求 如果submit失败的话，就整个流程重新来
          this.amazonCheckoutSessionId = '';
        })
        // .catch(this.showCreateFaileTips);
        .catch(this.handleSubmitFail);
    },
    handleSubmitFail(response) {
      let { errmsg, res } = response;
      // 2025-04-07 gmo升级v2需求 如果submit失败的话，就整个流程重新来
      this.amazonCheckoutSessionId = '';
      if (res && !!res.code) {
        switch (+res.code) {
          // 购物车提单超过限购数量
          case 120003: {
            const { data } = res;
            if (data && data.length) {
              let hasDealItem = data.filter(item => !item.canBuy);
              this.removeCartItemToLimit(hasDealItem);
            }
            break;
          }
        }
        return;
      }
      this.showCreateFaileTips(errmsg);
    },
    removeCartItemToLimit(hasDealItem) {
      hasDealItem &&
        hasDealItem.length &&
        hasDealItem.forEach(item => {
          this.$store.commit(SET_PRODUCT_OF_CART, item);
        });
      this.submitLoading = false;
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.limit_order_remove_tip);
    },
    showCreateFaileTips(err) {
      this.submitLoading = false;
      this.$store.commit(UPDATE_LOADING, false);
      let msg = typeof err === 'string' ? err : err.message;
      this.errTips = msg;
      this.showPopup = true;
    },
    showPayMonenyList() {
      if (this.canSelectMoney) {
        this.showPaymentSelecter = true;
      }
    },
    resetCurCard() {
      this.curCard =
        (this.curPayType?.user_infos?.length &&
          this.curPayType.user_infos[0]) ||
        {};
    },
    deleteCurPayTypeCard(keyValue) {
      const index = this.curPayType.user_infos.findIndex(
        item => item.KEY_VALUE === keyValue
      );
      this.curPayType.user_infos.splice(index, 1);

      // 若删除项不为当前选中的卡，不做处理
      if (keyValue !== this.curCard.KEY_VALUE) {
        return;
      }

      // 若删除项为当前选中的卡,重置
      this.resetCurCard();
    },

    changeCouponList() {
      this.resetPaytypeActiveCoupon();
      this.hasConfirmCoupon = false;

      if (
        this.isJpPlatform &&
        this.curPayType.f_pay_type === this.getPointPayChannelName
      ) {
        this.changePaytypeCouponList({
          game_id: this.gameId,
          product_id: this.curProduct.PRODUCT_ID
        });
        return;
      }

      if (!this.curPayType.coupon) {
        return;
      }

      this.changePaytypeCouponList({
        game_id: this.gameId,
        f_pay_type: this.curPayType.f_pay_type,
        pay_type: this.curPayType.pay_type,
        currency: this.curPrice.CURRENCY,
        amount: this.isCart ? this.cartTotalPrice : this.curPrice.TRANS_AMOUNT,
        product_type: this.isCart
          ? this.cartProductType
          : this.curProduct.PRODUCT_TYPE,
        product_id: this.isCart ? '' : this.curProduct.PRODUCT_ID,
        cp_product_id: this.isCart ? '' : this.curProduct.CP_PRODUCT_ID
      });
    },
    calCoin(coin) {
      if (!coin) {
        return 0;
      }
      if (typeof coin === 'number') {
        return coin;
      } else {
        return parseFloat(coin);
      }
    },
    cancleAirWalletPopup() {
      this.airWallexState = false;
      clickButton({
        btnName: `取消${this.airWallexInfo['point_name']}`
      });
    },
    handleAreaConfirmPopup() {
      if (this.isUidLogin) {
        this.visibleCommonTokenLoginPopup = true;
        return;
      }
      if (this.locaitonSelectable) {
        this.showAreaConfirmPopup = true;
        clickButton({
          btnName: 'select_regions',
          locationKey: locationType.paytypeSection
        });
      }
      return false;
    },
    checkLocationChange() {
      // 判断是否uid登录
      if (this.isUidLogin) return;
      // 判断是否有支付渠道
      if (!this.havePayWay) {
        this.showAreaConfirmPopup = true;
        return;
      }
      // 判断是否自动弹出过地区限制弹窗
      const haveAreaAutoPopupInfo = getAreaLimitAutoPopup();
      if (haveAreaAutoPopupInfo?.[this.gameId]) return;
      haveAreaAutoPopupInfo[this.gameId] = true;
      storeAreaLimitAutoPopup(haveAreaAutoPopupInfo);
      // 判断是否有更改地区限制次数
      if (!this.haveChangeAreaTimes) return;
      // 判断现在ip地址和记录地址是否一致
      if (this.ipLocation != this.curLocationVal) {
        this.showAreaConfirmPopup = true;
      }
    },
    cancelAreaConfirmPopup() {
      this.showAreaConfirmPopup = false;
    },
    confirmSwitchArea(params) {
      this.$store.commit(UPDATE_LOADING, true);
      window.webstorev3DataLayer.push({
        eventName: 'bind_region',
        eventType: 'manualselect',
        eventReason: this.maxLocationModifyCount - this.locationModifyCount - 1,
        eventValue: params.location_code
      });
      this.$store
        .dispatch(MODIFY_THIRD_PARTY_PAYMENT_INFOS, params)
        .then(res => {
          this.$store.commit(UPDATE_LOADING, false);
          this.cancelAreaConfirmPopup();
          this.handleZipCodeConfirmPopup(false);
          this.curLocation = params.location_name;
          this.curLocationVal = params.location_code;
          this.reloadWay();
        })
        .catch(errmsg => {
          this.$store.commit(UPDATE_LOADING, false);
          this.errTips = errmsg;
          this.showPopup = true;
        });
    },
    handleZipCodeConfirmPopup(state) {
      this.zipCodePopupMode = '';
      this.showZipCodeConfirmPopup = state;
    },
    // 确认zipcode然后提交
    confirmZipCodeAndPostOrder(params) {
      if (this.isUidLogin) {
        this.visibleCommonTokenLoginPopup = true;
        return;
      }
      this.$store.commit(UPDATE_LOADING, true);
      this.$store
        .dispatch(MODIFY_THIRD_PARTY_PAYMENT_INFOS, params)
        .then(res => {
          this.$store.commit(UPDATE_LOADING, false);
          this.handleZipCodeConfirmPopup(false);
          this.postOrder();
        })
        .catch(errmsg => {
          this.$store.commit(UPDATE_LOADING, false);
          this.errTips = errmsg;
          this.showPopup = true;
        });
    },
    handleGMOSubmit() {
      // 验证数据
      // this.showGMOSelectPopup = false;
      // 调用原有的提交订单方法
      this.doPostORder();
    },
    selectPrice(price) {
      this.curPrice = price;
    },
    // 2025-04-07 gmo升级v2需求 监听gmo的amazon pay渠道的支付窗口的回调sessionid  ，并赋值
    updateGMOAmazonPaySessionMessage(event) {
      let data = event?.data || {};
      if (
        data.action == 'gmo-amazon-pay-callback' &&
        data?.amazonCheckoutSessionId
      ) {
        this.amazonCheckoutSessionId = data.amazonCheckoutSessionId;
      }
    }
  },
  components: {
    PaymentSelecter,
    PointCard,
    ProductSelecter,
    SelectPayWay,
    CouponConfirmPopup,
    CoinsBalancePopup,
    AirWallexBtn,
    AreaConfirmPopup,
    CommonUidTokenLoginPopup,
    ZipCodeConfirmPopup,
    LoginInfo,
    OrderInfo,
    OrderProduct,
    Payment,
    BankPay,
    GMOSelectPopup
  }
};
</script>

<style lang="scss">
@import '@assets/scss/officialTopup/store.scss';
</style>
<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';

.back-btn {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  margin: 30px 0;
  margin-left: -15px;
  text-align: start;
  .back-ico {
    color: #333333;
    transform: rotate(180deg);
    width: 30px;
    height: 30px;
    margin-right: 15px;
  }
}
.pay-container {
  position: relative;
  box-sizing: border-box;
  width: 100%;

  .left {
    width: 100%;

    .login-info {
      border-radius: 20px;
      margin-bottom: 20px;
    }
    .order-product {
      border-radius: 20px 20px 0 0;
    }
    .order-info {
      border-radius: 0 0 20px 20px;
      margin-bottom: 20px;
    }
  }
  .right {
    width: 100%;
    margin-top: 21px;
    border-radius: 20px;

    .pay-info {
      display: flex;
      justify-content: space-between;
      margin: 40px auto 34px;
      align-items: center;
      .pay-title {
        color: #333333;
        font-size: 28px;
        font-weight: bold;
      }
      .area-selector {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #333;
        padding: 0 20px;
        height: 50px;
        background: #fff;
        @include g-border();
        border-radius: 20px;
        cursor: pointer;

        .area-icon {
          margin-left: 10px;
          width: 26px;
          height: 26px;
        }
      }
    }
    .submit-wrap {
      position: sticky;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      padding: 40px;
      width: 100%;
      z-index: 5;
      background: #ffffff;
      border-radius: 20px;
      .order-sum {
        margin-bottom: 30px;
        font-size: 24px;
        .total {
          font-size: 30px;
          margin-left: 10px;
          color: $themeColor;
          font-weight: bold;
        }
      }
    }
    .submit-btn {
      width: 100%;
      height: 59px;
      background-color: $themeColor;
      border-radius: 9px;
      font-size: 26px;
      line-height: 1.5;
      color: #f6f6f6;
    }
  }
}

.select-paytype-info {
  display: inline-block;
  width: 100%;
}

.tips-content {
  padding: 0;
}

.paytype-guide-tip {
  color: $themeColor;
  font-size: 24px;
  line-height: 30px;
  margin: -20px 0 20px;
  border: 2px dashed #dddddd;
  border-radius: 9px;
  padding: 10px 14px;
  background: #fff;
}

@media screen and (orientation: landscape) {
  .back-btn {
    margin: 0;
    font-size: 22px;
    font-weight: normal;
  }

  .pay-container {
    padding: 0;
    width: 100%;
    display: flex;

    .left {
      max-width: 600px;
      width: 50%;

      .login-info {
        border-radius: 20px;
        margin-bottom: 20px;
      }
      .order-product {
        border-radius: 20px;
        margin-bottom: 20px;
      }
      .order-info {
        border-radius: 20px;
        margin-bottom: 20px;
      }
    }
    .right {
      margin-top: 21px;
      margin-left: 20px;
      max-width: 580px;
      width: 50%;
      background-color: $moduleBackgroundColor;

      .pay-info {
        margin: 40px 20px 34px;
        align-items: center;
        .pay-title {
          font-size: 24px;
          font-weight: normal;
        }
        .area-selector {
          font-size: 18px;
        }
      }

      .submit-wrap {
        position: relative;
        bottom: 0;
        box-sizing: border-box;
        width: 100%;
        padding: 20px;
        border-radius: 20px;
        .order-sum {
          display: none;
        }
      }
    }
  }
  .select-paytype-info {
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    padding: 0 20px;
    max-height: 500px;
    overflow-y: scroll;
  }

  .tips-content {
    padding: 0;
  }

  .paytype-guide-tip {
    font-size: 22px;
  }
}
</style>
